import React,{ Component } from 'react';
import './Layout.scss'

import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import AppFooter from "@coreui/react/es/Footer";
import Footer from './Footer';
import Screen from "../../views/EventOrganizer/OpenScreen/Screen";

import Cookies from "js-cookie";
import axios_eventtag from "../../axios/axios_eventtag";
import apiConfig from "../../axios/axios_api_services";
import * as common from "../../const/Common/CommonFunc";
import ReceptSocketConfiguration from "../../views/Reception/ReceptSocketConfiguration/ReceptSocketConfiguration";
import * as keys from "../../const/key/Key";

class EventQuestionLayout extends Component {

  componentDidMount(){
    document.title = "Event Question Bank";
    this.getCurrentQuestion();
  }
  getCurrentQuestion = () => {
    this.props.spinnerHandler(true);

    axios_eventtag.get(apiConfig.GET_CURRENT_OPEN_QUESTION)
      .then(response => {
        if (response.data.success) {
          this.props.questionHandler(response.data.content);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getCurrentQuestion();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  render() {
    return(
      <div className="app event-question-bank-screen-wrapper">
        <div className="app-body event-question-bank-screen">
         <ReceptSocketConfiguration focus={keys.TOPIC_QUESTION}/>
         <Screen />
        </div>
        <AppFooter>
          <Footer/>
        </AppFooter>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user
});
const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // socket data store
    questionHandler : (data) => dispatch(actionCreator.questionHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventQuestionLayout);


